export {default as Permissions} from './Permissions';
export { default as permissionsStore } from "./permissionsStore";


// WEBPACK FOOTER //
// ./src/modules/admin/modules/Permissions/index.ts